import React, { useState, useEffect } from "react";
import { IoClose, IoVideocam } from "react-icons/io5"; // Import IoVideocam icon
import helpTopics from "../Guides/helpTopics.json"; // Import help topics JSON
import "./HelpModal.css"; // Import the CSS file for styling

interface HelpModalProps {
  showHelpModal: boolean;
  onClose: () => void;
  initialVideoUrl?: string | null; // Add initialVideoUrl prop
}

const HelpModal: React.FC<HelpModalProps> = ({
  showHelpModal,
  onClose,
  initialVideoUrl,
}) => {
  const [selectedHelpTopic, setSelectedHelpTopic] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (initialVideoUrl) {
      setSelectedHelpTopic(initialVideoUrl);
    }
  }, [initialVideoUrl]);

  const handleHelpTopicClick = (url: string) => {
    setSelectedHelpTopic(url);
  };

  const handleCloseVideoModal = () => {
    setSelectedHelpTopic(null);
  };

  return (
    <>
      {showHelpModal && (
        <div className="modal">
          <div className="help-modal-content">
            <button className="help-modal-close-button" onClick={onClose}>
              <IoClose size={20} />
            </button>
            <h2 className="help-modal-title">Help Center</h2>
            <p className="help-modal-description">
              Your guide to mastering FocusMap
            </p>

            <div className="help-container">
              <div className="help-areas">
                {helpTopics.map((area, areaIndex) => (
                  <div key={areaIndex} className="help-area">
                    <h3 className="help-area-title">{area.title}</h3>
                    <ul className="help-topic-items">
                      {area.videos.map((video, videoIndex) => (
                        <li
                          key={videoIndex}
                          onClick={() => handleHelpTopicClick(video.url)}
                          className={`help-topic-item ${
                            video.disabled ? "disabled" : ""
                          }`}
                        >
                          <span
                            dangerouslySetInnerHTML={{ __html: video.title }}
                          />
                          {!video.disabled && (
                            <IoVideocam
                              size={20}
                              color="white"
                              className="video-icon"
                            />
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      {selectedHelpTopic && (
        <div className="video-modal">
          <div className="video-modal-content">
            <button
              className="help-video-modal-close-button"
              onClick={handleCloseVideoModal}
            >
              <IoClose size={20} />
            </button>
            <video controls autoPlay className="video-player">
              <source src={selectedHelpTopic} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </>
  );
};

export default HelpModal;
